export const isReady = state => state.videoCategory.isReady
export const isCategoriesReady = state => state.videoCategory.isCategoriesReady
export const shouldLoadMoreVideos = state => state.videoCategory.shouldLoadMoreVideos
export const hasError = state => state.videoCategory.hasError === true
export const getErrorMessage = state => state.videoCategory.errorMessage
export const getParents = state => state.videoCategory.parents
export const getVideos = state =>
  state.videoCategory.videos.map(id => state.videoCategory.byId[id])
export const getCategories = state => state.videoCategory.categories
export const getFocusedSection = state => state.videoCategory.focusedSection
export const getFocusedPosition = state => state.videoCategory.focusedPosition
export const getCategoryVideos = state => state.videoCategory.categoryVideos
export const getOverviewItem = state => {
  if (state.videoCategory.overview.type === 'video') {
    if (
      state.videoCategory.overview.id > 0 &&
      typeof state.videoCategory.byId[state.videoCategory.overview.id] !== 'undefined'
    ) {
      return {
        type: 'video',
        item: state.videoCategory.byId[state.videoCategory.overview.id],
      }
    }
  } else if (state.videoCategory.overview.type === 'category') {
    if (
      typeof state.videoCategory.categories[state.videoCategory.overview.id] !==
      'undefined'
    ) {
      return {
        type: 'category',
        item: state.videoCategory.categories[state.videoCategory.overview.id],
      }
    }
  }
  return {
    type: 'unknown',
    item: null,
  }
}
